import { lazy } from 'react';

export const DatabasePageLazy = lazy(() => import('./DatabasePage'));
